module.exports = __webpack_public_path__ + "img/LevaTalk-Logo.4561ef90.png";